import { render } from "./CreateOrganizationPromptModal.vue?vue&type=template&id=847989c8&scoped=true"
import script from "./CreateOrganizationPromptModal.vue?vue&type=script&lang=js"
export * from "./CreateOrganizationPromptModal.vue?vue&type=script&lang=js"

import "./CreateOrganizationPromptModal.vue?vue&type=style&index=0&id=847989c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-847989c8"]])

export default __exports__